export type BlueprintPageWrapperProps = {
	pageNumber?: number;
	children: React.ReactNode;
};

/**
 * PDF proposalPage style equivalents (landscape letter 792×612pt, scale 1.389 to 1100px):
 * paddingTop: 0 → 0 (using 14px for symmetry with bottom)
 * paddingBottom: 10pt → 14px
 * paddingHorizontal: 15pt → 21px
 * fontSize: 10pt → 14px
 */
export const BlueprintPageWrapper = (props: BlueprintPageWrapperProps): React.ReactElement => {
	const { pageNumber, children } = props;

	return (
		<div data-blueprint-page={pageNumber} style={{
			width: '1100px',
			height: '850px',
			flexShrink: 0,
			margin: '0 auto 20px auto',
			backgroundColor: '#FFF',
			boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
			position: 'relative',
			overflow: 'hidden',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			paddingTop: '55px',
			paddingBottom: '43px',
			paddingLeft: '74px',
			paddingRight: '74px',
			fontFamily: "'Inter', sans-serif",
			fontWeight: 400,
			fontSize: '14px',
			contain: 'layout style paint'
		}}>
			{children}
		</div>
	);
};
